import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AdminUsersRoutes, UserUsersAndPaxRoutes } from 'src/app/core/enums/routes.enum';
import { MenuListLogicService } from 'src/app/core/services/menu-list-logic.service';

@Component({
  selector: 'app-ui-navigate-to-person',
  templateUrl: './ui-navigate-to-person.component.html',
  styleUrls: ['./ui-navigate-to-person.component.scss'],
  standalone: false,
})
export class UiNavigateToPersonComponent {
  @Input() id: string;
  @Input() type: 'user' | 'pax' = 'user';
  @Input() stopPropagation = false;
  @Input() buttonClass = '';

  constructor(
    private router: Router,
    private menuListLogicService: MenuListLogicService
  ) {}

  navigateToPerson(event?: MouseEvent): void {
    if (this.stopPropagation && event) {
      event.stopPropagation();
    }

    const isInAdmin = this.menuListLogicService.isCurrentUrlInAdmin();

    if (this.type === 'user') {
      this.router.navigateByUrl(
        isInAdmin
          ? `${AdminUsersRoutes.Users}/${this.id}/(detailsOut:details)`
          : `${UserUsersAndPaxRoutes.Users}/${this.id}/(detailsOut:details)`
      );
    } else {
      this.router.navigateByUrl(
        isInAdmin
          ? `${AdminUsersRoutes.Paxes}/${this.id}`
          : `${UserUsersAndPaxRoutes.Paxes}/${this.id}`
      );
    }
  }
}
